import React from "react";

interface AlertProps {
  tone: "error" | "success" | "warning" | "info";
  children: React.ReactNode;
  onDismiss?: () => void;
}

export default function Alert({ tone, children, onDismiss }: AlertProps) {
  const role = tone === "error" || tone === "warning" ? "alert" : "status";

  return (
    <div className={`alert-${tone}`} role={role}>
      <div className="flex items-start justify-between gap-2">
        <span>{children}</span>
        {onDismiss && (
          <button
            type="button"
            onClick={onDismiss}
            aria-label="Dismiss"
            className="shrink-0 opacity-70 hover:opacity-100 transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-current rounded"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="h-4 w-4"
              aria-hidden="true"
            >
              <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
